/* repo/pos*/
import { lensPath } from "ramda";
import {
  fetch as fetchApi,
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { PosCodec, Pos, Data } from "../store/pos/types";
import { withDecoded, flattenData } from "./";

function mapToModel(data: object): Pos {
  return withDecoded(PosCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(pos: Data): Data {
  return {
    ...pos,
    attributes: {
      ...pos.attributes,
      POSSoftware: pos.attributes.POSSoftwarePresentation?.id || undefined,
    },
  };
}

export async function fetch(id: string | null, params?: {}): Promise<Pos> {
  return fetchApi({
    nestedResourcePath: ["pos"],
    id: id,
    params: params,
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(pos: Data): Promise<Pos> {
  return insertApi({
    nestedResourcePath: ["pos"],
    id: pos.id,
    data: { data: mapToChageset(pos) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function drop(id: string | null): Promise<boolean> {
  return dropApi({
    nestedResourcePath: ["pos"],
    id: id,
  }).then(() => true);
}
